import * as TYPE from './actionType.js';

export function checkoutData(checkoutData) {
  return { type: TYPE.CHECKOUTDATA, data: checkoutData };
}
